import styled from 'styled-components';

export const SignatureContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;

export const Canvas = styled.canvas`
  width: 100%;
  height: 200px;
  border: 1px solid #ccc;
  border-radius: 4px;
  background: #fff;
  touch-action: none;
`;

export const Buttons = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  margin-top: 16px;
`;

export const ButtonClear = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;

  padding: 8px 24px;
  border: 0;
  border-radius: 4px;
  background: #3aafa9;
  color: #fff;
  font-size: 14px;
  font-weight: 600;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  & + & {
    background: transparent;
    border: 1px solid #ccc;
    color: #555;
  }
`;
